import React from "react";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import { List } from "@mui/material";

export default function FileItem({
  files,
  removeFile,
  displayDeleteButton,
}) {
  return (
    <List>
      {files.map((f, index) => {
        // Determinar el ID único del archivo
        const key =
          f.__id || f.id || f.name || f.fileName || index;

        // URL del archivo (imagen o PDF)
        const src =
          f.preview || // archivos nuevos (dropzone)
          f.uri ||     // archivos existentes (backend)
          f.path || "";

        // Nombre del archivo
        const fileName = f.name || f.fileName || "Sin nombre";

        // Tipo de archivo
        const fileType = f.type || f.fileType || "";

        return (
          <ListItem
            key={key}
            divider={true}
            secondaryAction={
              displayDeleteButton && (
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => {
                    // Si tiene ID (backend), enviar ID
                    if (f.id) {
                      
                      removeFile(f.id);
                    }
                    // Si es un archivo nuevo (dropzone), enviar __id
                    else if (f.__id) {
                      removeFile(f.__id);
                    }
                    // Fallback: usar nombre
                    else {
                      removeFile(f.name || f.fileName);
                    }
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              )
            }
          >
            <ListItemAvatar>
              {fileType === "application/pdf" ? (
                <iframe
                  src={src}
                  title={fileName}
                  style={{
                    width: "100%",
                    height: "400px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <img
                  src={src}
                  alt={fileName}
                  style={{
                    width: "300px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "4px",
                    border: "1px solid #ddd",
                  }}
                />
              )}
            </ListItemAvatar>

            <ListItemText primary={fileName} />
          </ListItem>
        );
      })}
    </List>
  );
}
